import Action from "@Actions/action";
import { Events } from "@Context/common/general/context";
import { isNumber } from "lodash-es";
export default class Navigate extends Action {
  
  runAction() {
    Events.app.navigate.emit({
      path: this._payload.path,
      data: this._payload.data,
      replace: this._payload.replace,
    });

    super.onSuccess();
    return;

    if (this._payload.path === window.location.pathname && !(this._payload.forceNavigation)) {
      return;
    }

    if (isNumber(this._payload.delay)) {
      setTimeout(() => {
        this.runAction();
        this._payload.delay = null;
      }, this._payload.delay);
      return;
    }

    // Data passed between transition pages
    const pageData = this._payload.data || null;

    // if (!this._payload.to_page && (this._payload.path)) {
    //   return;
    // }

    const navigate = (lastPath) => {
      this._state.app.events.navigate.emit({
        path: this._payload.path,
        data: pageData,
        callback: () => {
          setTimeout(() => {
            this._state.app.events.animatePageIn.emit({
              path: this._payload.path,
              lastPath: lastPath,
              page_id: this._payload.to_page,
              direction: this._payload.direction === 'LEFT' ? 'LEFT' : 'RIGHT',
              forceNavigation: this._payload.forceNavigation || false,
              data: pageData,
            });
          }, 0);
        }
      });
    }

    const onAnimateOutFinished = (props = {}) => {
      navigate(props.lastPath);
    }

    let animateOutReceieved = false;

    const onAnimateOutReceived = () => {
      animateOutReceieved = true;
    }

    this._state.app.events.animatePageOut.emit({
      path: this._payload.path,
      page_id: this._payload.from_page,
      direction: this._payload.direction,
      forceNavigation: this._payload.forceNavigation || false,
      onAnimateOutReceived: onAnimateOutReceived,
      onFinished: onAnimateOutFinished
    });

    setTimeout(() => {
      if (!animateOutReceieved) {
        navigate();
      }
    }, 50);
  }
}
